import { createReducer } from "@reduxjs/toolkit";
import { impersonateUser, resetUserImpersonation, stopImpersonation } from "./impersonate-user";
import type { RetrievalState } from "@redux/state/shared-types";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import type { ROLES } from "@user-management-context/shared/domain/types/enums/roles";

type ImpersonationPayload = { activeRole: ROLES };

const initialState: RetrievalState<Nullable<ImpersonationPayload>> = {
  fetching: "idle",
  data: null,
};

export const impersonateUserReducer = createReducer<RetrievalState<Nullable<ImpersonationPayload>>>(initialState, builder => {
  builder
    .addCase(impersonateUser.pending, state => ({
      ...state,
      fetching: "pending",
    }))
    .addCase(impersonateUser.fulfilled, (state, { payload }) => ({
      ...state,
      fetching: "success",
      data: payload,
    }))
    .addCase(impersonateUser.rejected, state => ({
      ...state,
      fetching: "failed",
    }))
    .addCase(stopImpersonation, () => initialState)
    .addCase(resetUserImpersonation, () => initialState);
});
